import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Box,
  Button,
} from "@mui/material";
import "./faq.css";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function FAQ() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const categories = ["All", "General", "For Clients", "For Lawyers"];

  const faqData = {
    General: [
      {
        question: "What is Quidpro?",
        answer:
          "Quidpro is an AI-powered platform that connects clients with qualified lawyers for online and in-person consultations. Our AI also provides basic legal advice to help you get started.",
      },
      {
        question: "How does the AI legal advice work?",
        answer:
          "Our AI assistant uses natural language processing to provide quick answers to basic legal questions. It helps you understand your issue before speaking to a lawyer.",
      },
      {
        question: "Can I choose my lawyer?",
        answer:
          "Yes, you can browse our lawyer directory and select a lawyer based on their expertise, ratings, and availability. The AI can also recommend suitable lawyers for your needs.",
      },
      {
        question: "How much does it cost to use Quidpro?",
        answer:
          "We offer free and paid pricing plans. You can access basic AI advice for free, while lawyer consultations are priced according to the lawyer’s rate.",
      },
      {
        question: "Is my information confidential?",
        answer:
          "Yes, all communication is encrypted, and information is only shared with your selected lawyer. Please review our Privacy Policy for more details.",
      },
      {
        question: "How do I book a consultation?",
        answer:
          "After signing up, you can search for a lawyer or use our AI recommendation. Choose a lawyer and select a convenient time to book the appointment.",
      },
      {
        question:
          "Can I get a refund if I'm not satisfied with my consultation?",
        answer:
          "Refunds are handled on a case-by-case basis. Contact our support team for assistance.",
      },
      {
        question: "What types of legal issues can Quidpro help with?",
        answer:
          "Quidpro covers areas like family law, business law, immigration, criminal law, and more. The AI guides you to the right lawyer for your issue.",
      },
    ],
    "For Clients": [
      {
        question: "How do I know if a lawyer is qualified?",
        answer:
          "All lawyers on our platform are vetted for their qualifications, licenses, and experience. Check their profiles, ratings, and reviews from other clients.",
      },
      {
        question: "Can I reschedule or cancel a consultation?",
        answer:
          "Yes, you can reschedule or cancel up to 24 hours before the scheduled time through the app.",
      },
      {
        question: "What happens if I miss my consultation?",
        answer:
          "Missed consultations without notice may be marked as completed and charged. Please notify your lawyer or our support team if you can’t attend.",
      },
      {
        question: "Can I upload documents for my lawyer to review?",
        answer:
          "Yes, you can securely upload documents before or during the consultation. Documents are only shared with your selected lawyer.",
      },
    ],
    "For Lawyers": [
      {
        question: "How can I join the platform as a lawyer?",
        answer:
          "Sign up and complete the verification process with your qualifications, licenses, and expertise. Once approved, you can start accepting clients.",
      },
      {
        question: "What are the subscription plans for lawyers?",
        answer:
          "We offer Basic, Premium, Enterprise, and Custom subscription plans for lawyers and firms. Visit our Pricing Page for more details.",
      },
      {
        question: "Can I manage my availability on the platform?",
        answer:
          "Yes, you can set your working hours and availability directly from the app.",
      },
      {
        question: "How do I get paid?",
        answer:
          "Payments are processed through our platform, and payouts are made directly to your bank account.",
      },
      {
        question: "Can I offer consultations in multiple regions?",
        answer:
          "Yes, provided you’re qualified to practice in those regions. Update your profile to reflect your licenses and expertise.",
      },
      {
        question: "Can I upload documents for clients during consultations?",
        answer:
          "Yes, documents can be uploaded and shared securely during consultations, streamlining the process.",
      },
    ],
  };

  const filteredQuestions =
    selectedCategory === "All"
      ? Object.values(faqData).flat()
      : faqData[selectedCategory] || [];
  return (
    <div className="faq-section">
      <p className="faq-section-title">Frequently Asked Questions</p>
      <p className="faq-section-description">
        Discover answers to frequently asked questions about our platform, from
        booking consultations to using AI for legal advice. Whether you're a
        client or a lawyer, our FAQ section provides the guidance you need to
        navigate and maximize your experience.
      </p>
      <TextField
        sx={{ marginTop: "3rem", backgroundColor: "white" }}
        label="Search products..."
        variant="outlined"
        fullWidth
        className="search-bar"
      />
      <div className="faq-categories">
        {["All", "General", "For Clients", "For Lawyers"].map(
          (category, index) => (
            <Button
              key={index}
              variant="outlined"
              className={`faq-category-button ${
                selectedCategory === category ? "selected" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
              sx={{ m: 2 }}
            >
              <p>{category}</p>
            </Button>
          )
        )}
      </div>
      <div className="faq-accordion">
        {filteredQuestions.map((faq, index) => (
          <Accordion
            key={index}
            className="faq-item"
            elevation={0}
            disableGutters
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="question-text"
            >
              {faq.question}
            </AccordionSummary>
            <AccordionDetails className="answer-text">
              {faq.answer}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
